"use strict";
window.theme = window.theme || {}
theme.customEngraving = function() {

    function customEngraving() {
        this.btn = {
            product_page_bottle: document.querySelector('button.product-engraving__button.engraving-bottle-button'),
            product_page_glass: document.querySelector('button.product-engraving__button.engraving-glass-button'),
            product_page_drop: document.querySelector('button.product-engraving__button.engraving-drop-button'),
            product_page_bottle_close: document.querySelector('button.engraving-glass'),
            product_page_glass_close: document.querySelector('button.engraving-bottle'),
            product_page_drop_close: document.querySelector('button.engraving-drop'),
            product_page_glass_prev: document.querySelector('.engraving-form-toggle .prev'),
            product_page_glass_next: document.querySelector('.engraving-form-toggle .next'),
            product_page_add_to_cart: document.querySelector('.add-to-cart__button'),
            mobile_add_to_cart: document.querySelectorAll('.engraving-add-to-cart__button'),
            product_edit_engrave: document.querySelectorAll('.engraving-edit__button'),
            product_page_glass_bullet_prev: document.querySelector('.engraving-form-toggle-bullets > li.prev'),
            product_page_glass_bullet_next: document.querySelector('.engraving-form-toggle-bullets > li.next')
        }
        this.selector = {
            product_custom_engrave_bottle: document.querySelector('.custom-engraving-form-bottle'),
            product_custom_engrave_glass: document.querySelector('.custom-engraving-form-glass'),
            product_custom_engrave_drop: document.querySelector('.custom-engraving-form-drop'),
            product_custom_engrave_glass_firstline: document.querySelector('.custom-engraving-form-glass .custom-engraving-first-line'),
            product_custom_engrave_glass_secondline: document.querySelector('.custom-engraving-form-glass .custom-engraving-second-line'),
            product_custom_engrave_drop_firstline: document.querySelector('.custom-engraving-form-drop .custom-engraving-first-line'),
            product_custom_engrave_drop_secondline: document.querySelector('.custom-engraving-form-drop .custom-engraving-second-line'),
            header_sticky: document.querySelector('.header__outer-wrapper'),
            magic_360_container: document.querySelector('.MagicToolboxContainer .product-engrave-preview')
        }
        this.input = {
            bottle_firstline: document.querySelector('.custom-engraving-form-bottle [name="engraving[firstline]"]'),
            bottle_secondline: document.querySelector('.custom-engraving-form-bottle [name="engraving[secondline]"]'),
            bottle_thirdline: document.querySelector('.custom-engraving-form-bottle [name="engraving[thirdline]"]'),
            glass_firstline: document.querySelector('.custom-engraving-form-glass [name="engraving[firstline]"]'),
            glass_secondline: document.querySelector('.custom-engraving-form-glass [name="engraving[secondline]"]'),
            drop_firstline: document.querySelector('.custom-engraving-form-drop [name="engraving[firstline]"]'),
            drop_secondline: document.querySelector('.custom-engraving-form-drop [name="engraving[secondline]"]'),
            glass_term_sales: document.querySelector('.custom-engraving-form-glass [name="engraving[terms_sales]"]'),
            bottle_term_sales: document.querySelector('.custom-engraving-form-bottle [name="engraving[terms_sales]"]'),
            drop_term_sales: document.querySelector('.custom-engraving-form-drop [name="engraving[terms_sales]"]'),
        }
        this.label = {
            bottle_firstline: document.querySelector('.custom-engraving-form-bottle [for="engraving_first_line"]'),
            bottle_secondline: document.querySelector('.custom-engraving-form-bottle [for="engraving_second_line"]'),
            bottle_thirdline: document.querySelector('.custom-engraving-form-bottle [for="engraving_third_line"]'),
            glass_firstline: document.querySelector('.custom-engraving-form-glass [for="engraving_first_line"]'),
            glass_secondline: document.querySelector('.custom-engraving-form-glass [for="engraving_second_line"]'),
            drop_firstline: document.querySelector('.custom-engraving-form-drop [for="engraving_first_line"]'),
            drop_secondline: document.querySelector('.custom-engraving-form-drop [for="engraving_second_line"]'),
            toggle_glass_label: document.querySelector('.customer-engraving-header > h4'),
            toggle_glass_mobile_label: document.querySelector('.customer-engraving-header.mobile-only > h4'),
            header_glass_label: document.querySelector('.customer-engraving-header .engraving-glass > span'),
            header_bottle_label: document.querySelector('.custom-engraving-form-bottle .engraving-bottle > span'),
            header_drop_label: document.querySelector('.custom-engraving-form-drop .engraving-drop > span')
        }
        this.preview = {
            thumbnails_slider: document.querySelectorAll('.product-thumbnails .product-thumbnails__item .product-thumbnails__item-inner > a'),
            firstline_straight_preview: document.querySelector('.product-engrave-preview .firstline-straight'),
            firstline_curve_preview: document.querySelector('.product-engrave-preview .firstline-curve'),
            secondline_straight_preview: document.querySelector('.product-engrave-preview .secondline-straight'),
            secondline_curve_preview: document.querySelector('.product-engrave-preview .secondline-curve'),
            thirdline_curve_preview: document.querySelector('.product-engrave-preview .thirdline-curve'),
            firstline_straight_text_preview: document.querySelector('.product-engrave-preview .firstline-straight > h2'),
            secondline_straight_text_preview: document.querySelector('.product-engrave-preview .secondline-straight > h2'),
            firstline_curve_text_preview: document.querySelector('.product-engrave-preview .firstline-curve > div'),
            secondline_curve_text_preview: document.querySelector('.product-engrave-preview .secondline-curve > div'),
            thirdline_curve_text_preview: document.querySelector('.product-engrave-preview .thirdline-curve > div'),
            mobile_firstline_straight_preview: document.querySelector('.product-engrave-mobile-preview .firstline-straight'),
            mobile_firstline_curve_preview: document.querySelector('.product-engrave-mobile-preview .firstline-curve'),
            mobile_secondline_straight_preview: document.querySelector('.product-engrave-mobile-preview .secondline-straight'),
            mobile_secondline_curve_preview: document.querySelector('.product-engrave-mobile-preview .secondline-curve'),
            mobile_firstline_straight_text_preview: document.querySelector('.product-engrave-mobile-preview .firstline-straight > h2'),
            mobile_secondline_straight_text_preview: document.querySelector('.product-engrave-mobile-preview .secondline-straight > h2'),
            mobile_firstline_curve_text_preview: document.querySelector('.product-engrave-mobile-preview .firstline-curve > div'),
            mobile_secondline_curve_text_preview: document.querySelector('.product-engrave-mobile-preview .secondline-curve > div'),
            mobile_thirdline_curve_preview: document.querySelector('.product-engrave-mobile-preview .thirdline-curve'),
            mobile_thirdline_curve_text_preview: document.querySelector('.product-engrave-mobile-preview .thirdline-curve > div'),
            product_thumbnails: document.querySelector('.product-thumbnails'),
            mobile_glass: document.querySelector('.product-engrave-preview.glass'),
            mobile_drop: document.querySelector('.product-engrave-preview.drop'),
            mobile_bottle: document.querySelector('.product-engrave-preview.bottle'),
            mobile_preview: document.querySelectorAll('.product-engrave-preview'),
            arrow_slider: document.querySelectorAll('.pdp-carousel-arrow'),
            product_magic360_thumbnails: document.querySelector('.MagicToolboxContainer'),
            magic360_thumbnails_slider: document.querySelectorAll('.MagicToolboxSelectorsContainer > a'),
            magic360_firstline_curve_preview: document.querySelector('.MagicToolboxContainer .product-engrave-preview .firstline-curve'),
            magic360_firstline_curve_text_preview: document.querySelector('.MagicToolboxContainer .product-engrave-preview .firstline-curve > div'),
            magic360_secondline_curve_preview: document.querySelector('.MagicToolboxContainer .product-engrave-preview .secondline-curve'),
            magic360_secondline_curve_text_preview: document.querySelector('.MagicToolboxContainer .product-engrave-preview .secondline-curve > div'),
            magic360_thirdline_curve_preview: document.querySelector('.MagicToolboxContainer .product-engrave-preview .thirdline-curve'),
            magic360_thirdline_curve_text_preview: document.querySelector('.MagicToolboxContainer .product-engrave-preview .thirdline-curve > div')
        }
        this.load();

    }
    customEngraving.prototype.load = function() {
        var _ = this; 
        if(_.btn.product_page_bottle) {
           _.btn.product_page_bottle.addEventListener('click', (event) => {
            dataLayer.push({
                'event': 'engrave_click'
            });
                _.openmaker(event);
           });      
        }
        if(_.btn.product_page_glass) {
            _.btn.product_page_glass.addEventListener('click', (event) => {
                _.openmaker(event);
            });      
        }
        if(_.btn.product_page_drop) {
            _.btn.product_page_drop.addEventListener('click', (event) => {
                _.openmaker(event);
            });      
        }
        if(_.btn.product_page_bottle_close) {
            _.btn.product_page_bottle_close.addEventListener('click', (event) => {
                _.closemaker(event);
            });    
        }
        if( _.btn.product_page_glass_close) {
            _.btn.product_page_glass_close.addEventListener('click', (event) => {
                _.closemaker(event);
            });    
        }
        if( _.btn.product_page_drop_close) {
            _.btn.product_page_drop_close.addEventListener('click', (event) => {
                _.closemaker(event);
            });    
        }
        if(_.input.bottle_firstline) {
            _.input.bottle_firstline.addEventListener('keyup', (event) => {
                let remaining_char = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length);
                if(remaining_char >= 0) {
                    event.target.nextElementSibling.innerHTML = remaining_char + ' ' + event.target.getAttribute('data-text-remaining');
                } else {
                    const input_value = event.target.value;
                    const newValue = input_value.slice(0, -1);
                    event.target.value = newValue;
                }
                if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                    if( _.preview.firstline_straight_text_preview)_.preview.firstline_straight_text_preview.innerHTML = event.target.value;
                    if(_.preview.mobile_firstline_straight_text_preview)_.preview.mobile_firstline_straight_text_preview.innerHTML = event.target.value;
                }     
                if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                    if(_.preview.firstline_curve_text_preview) {
                    _.preview.firstline_curve_text_preview.innerHTML = event.target.value;                   
                    let bottle_firstline = new CircleType(_.preview.firstline_curve_text_preview);
                    bottle_firstline.dir(-1).radius(138);          
                    bottle_firstline.forceHeight(false);  
                    bottle_firstline.forceWidth(false);    
                    bottle_firstline.refresh();   
                    }
                    if(_.preview.magic360_firstline_curve_text_preview) {
                        _.preview.magic360_firstline_curve_text_preview.innerHTML = event.target.value;                   
                        let bottle_firstline = new CircleType(_.preview.magic360_firstline_curve_text_preview);
                        bottle_firstline.dir(-1).radius(188);          
                        bottle_firstline.forceHeight(false);  
                        bottle_firstline.forceWidth(false);    
                        bottle_firstline.refresh();   
                        }
                    if(_.preview.mobile_firstline_curve_text_preview) {
                    _.preview.mobile_firstline_curve_text_preview.innerHTML = event.target.value;
                    let mobile_bottle_firstline = new CircleType(_.preview.mobile_firstline_curve_text_preview);
                    mobile_bottle_firstline.dir(-1).radius(148);    
                    mobile_bottle_firstline.forceHeight(false); 
                    mobile_bottle_firstline.forceWidth(false); 
                    mobile_bottle_firstline.refresh();   
                    }
                }     
                if(_.input.bottle_term_sales.checked && _.input.bottle_firstline.value !== '' || _.input.bottle_term_sales.checked && _.input.bottle_secondline.value !== '' || _.input.bottle_term_sales.checked && _.input.bottle_thirdline.value !== '') {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                    if(_.btn.mobile_add_to_cart.length>0) {
                     _.btn.mobile_add_to_cart.forEach(el => {
                          el.removeAttribute('disabled');
                          el.addEventListener('click', event => {
                              _.closemaker(event);
                          })
                     })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                             _.btn.product_edit_engrave.forEach(el => {
                                 el.removeAttribute('disabled');
                                 el.addEventListener('click', event => {
                                    _.closemaker(event);
                                })
                             })
                     }
                 }  else {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                    if(_.btn.mobile_add_to_cart.length>0) {
                        _.btn.mobile_add_to_cart.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                        _.btn.product_edit_engrave.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                 }                  
            })
            _.input.bottle_firstline.addEventListener('focus', (event) => {
            _.label.bottle_firstline.classList.add('focus');
            if(_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position')) - 1])_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position')) - 1].click();   
            if(_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();         
            if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.add('active');
                _.preview.secondline_curve_preview.classList.remove('active');
                _.preview.secondline_straight_preview.classList.add('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.add('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.add('active');
                _.preview.mobile_thirdline_curve_preview.classList.remove('active');
            }     
            if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                if(_.preview.firstline_curve_preview)_.preview.firstline_curve_preview.classList.add('active');
                if(_.preview.firstline_straight_preview)_.preview.firstline_straight_preview.classList.remove('active');
                if(_.preview.secondline_curve_preview)_.preview.secondline_curve_preview.classList.add('active');
                if(_.preview.secondline_straight_preview)_.preview.secondline_straight_preview.classList.remove('active');
                if(_.preview.thirdline_curve_preview)_.preview.thirdline_curve_preview.classList.add('active');
                if(_.preview.mobile_firstline_curve_preview)_.preview.mobile_firstline_curve_preview.classList.add('active');
                if(_.preview.mobile_firstline_straight_preview)_.preview.mobile_firstline_straight_preview.classList.remove('active');
                if(_.preview.mobile_secondline_curve_preview)_.preview.mobile_secondline_curve_preview.classList.add('active');
                if(_.preview.mobile_thirdline_curve_preview)_.preview.mobile_thirdline_curve_preview.classList.add('active');
                if(_.preview.mobile_secondline_straight_preview)_.preview.mobile_secondline_straight_preview.classList.remove('active');
                if(_.preview.magic360_firstline_curve_preview)_.preview.magic360_firstline_curve_preview.classList.add('active');
                if(_.preview.magic360_secondline_curve_preview)_.preview.magic360_secondline_curve_preview.classList.add('active');
                if(_.preview.magic360_thirdline_curve_preview)_.preview.magic360_thirdline_curve_preview.classList.add('active');
            }     
         })
           _.input.bottle_firstline.addEventListener('focusout', (event) => {
                 if(event.target.value === '') {
                     _.label.bottle_firstline.classList.remove('focus');
                 }           
             })
         }  
         if(_.input.bottle_secondline) {
            _.input.bottle_secondline.addEventListener('keyup', (event) => {
                let remaining_char = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length);
                if(remaining_char >= 0) {
                    event.target.nextElementSibling.innerHTML = remaining_char + ' ' + event.target.getAttribute('data-text-remaining');
                } else {
                    const input_value = event.target.value;
                    const newValue = input_value.slice(0, -1);
                    event.target.value = newValue;
                }
                if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                    if( _.preview.secondline_straight_text_preview) _.preview.secondline_straight_text_preview.innerHTML = event.target.value;
                    if(_.preview.mobile_secondline_straight_text_preview)_.preview.mobile_secondline_straight_text_preview.innerHTML = event.target.value;
                }     
                if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                    if(_.preview.secondline_curve_text_preview) {
                        _.preview.secondline_curve_text_preview.innerHTML = event.target.value;
                        let bottle_secondline = new CircleType(_.preview.secondline_curve_text_preview);
                        bottle_secondline.dir(-1).radius(168);   
                        bottle_secondline.forceHeight(false); 
                        bottle_secondline.forceWidth(false);   
                        bottle_secondline.refresh();   
                    } 
                    if(_.preview.magic360_secondline_curve_text_preview) {
                        _.preview.magic360_secondline_curve_text_preview.innerHTML = event.target.value;                   
                        let bottle_secondline = new CircleType(_.preview.magic360_secondline_curve_text_preview);
                        bottle_secondline.dir(-1).radius(238);          
                        bottle_secondline.forceHeight(false);  
                        bottle_secondline.forceWidth(false);    
                        bottle_secondline.refresh();   
                    }
                    if(_.preview.mobile_secondline_curve_text_preview) {
                        _.preview.mobile_secondline_curve_text_preview.innerHTML = event.target.value;
                        let mobile_bottle_secondline = new CircleType(_.preview.mobile_secondline_curve_text_preview);
                        mobile_bottle_secondline.dir(-1).radius(187);  
                        mobile_bottle_secondline.forceHeight(false);  
                        mobile_bottle_secondline.forceWidth(false); 
                        mobile_bottle_secondline.refresh();   
                    }                               
                } 
                if(_.input.bottle_term_sales.checked && _.input.bottle_firstline.value !== '' || _.input.bottle_term_sales.checked && _.input.bottle_secondline.value !== ''  || _.input.bottle_term_sales.checked && _.input.bottle_thirdline.value !== '') {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                    if(_.btn.mobile_add_to_cart.length>0) {
                     _.btn.mobile_add_to_cart.forEach(el => {
                          el.removeAttribute('disabled');
                          el.addEventListener('click', event => {
                              _.closemaker(event);
                          })
                     })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                             _.btn.product_edit_engrave.forEach(el => {
                                 el.removeAttribute('disabled');
                                 el.addEventListener('click', event => {
                                    _.closemaker(event);
                                })
                             }) 
                     }
                 }  else {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                    if(_.btn.mobile_add_to_cart.length>0) {
                        _.btn.mobile_add_to_cart.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                 } 
            })
            _.input.bottle_secondline.addEventListener('focus', (event) => {
            _.label.bottle_secondline.classList.add('focus');
            if(_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();   
            if(_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();            
            if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.add('active');
                _.preview.secondline_curve_preview.classList.remove('active');
                _.preview.secondline_straight_preview.classList.add('active');
                _.preview.thirdline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.add('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.add('active');
                _.preview.mobile_thirdline_curve_preview.classList.remove('active');
            }     
            if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                if(_.preview.firstline_curve_preview)_.preview.firstline_curve_preview.classList.add('active');
                if(_.preview.firstline_straight_preview)_.preview.firstline_straight_preview.classList.remove('active');
                if(_.preview.secondline_curve_preview)_.preview.secondline_curve_preview.classList.add('active');
                if(_.preview.secondline_straight_preview)_.preview.secondline_straight_preview.classList.remove('active');
                if(_.preview.thirdline_curve_preview)_.preview.thirdline_curve_preview.classList.add('active');
                if(_.preview.mobile_firstline_curve_preview)_.preview.mobile_firstline_curve_preview.classList.add('active');
                if(_.preview.mobile_firstline_straight_preview)_.preview.mobile_firstline_straight_preview.classList.remove('active');
                if(_.preview.mobile_secondline_curve_preview)_.preview.mobile_secondline_curve_preview.classList.add('active');
                if(_.preview.mobile_secondline_straight_preview)_.preview.mobile_secondline_straight_preview.classList.remove('active');
                if(_.preview.mobile_thirdline_curve_preview)_.preview.mobile_thirdline_curve_preview.classList.add('active');
                if(_.preview.magic360_firstline_curve_preview)_.preview.magic360_firstline_curve_preview.classList.add('active');
                if(_.preview.magic360_secondline_curve_preview)_.preview.magic360_secondline_curve_preview.classList.add('active');
                if(_.preview.magic360_thirdline_curve_preview)_.preview.magic360_thirdline_curve_preview.classList.add('active');
            }     
         })
           _.input.bottle_secondline.addEventListener('focusout', (event) => {
                 if(event.target.value === '') {
                     _.label.bottle_secondline.classList.remove('focus');
                 }           
             })
         }  
         if(_.input.bottle_thirdline) {
            _.input.bottle_thirdline.addEventListener('keyup', (event) => {
                let remaining_char = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length);
                if(remaining_char >= 0) {
                    event.target.nextElementSibling.innerHTML = remaining_char + ' ' + event.target.getAttribute('data-text-remaining');
                } else {
                    const input_value = event.target.value;
                    const newValue = input_value.slice(0, -1);
                    event.target.value = newValue;
                }
                if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                    if( _.preview.thirdline_straight_text_preview) _.preview.secondline_thirdline_text_preview.innerHTML = event.target.value;
                    if(_.preview.mobile_thirdline_straight_text_preview)_.preview.mobile_thirdline_straight_text_preview.innerHTML = event.target.value;
                }     
                if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                    if(_.preview.thirdline_curve_text_preview) {
                        _.preview.thirdline_curve_text_preview.innerHTML = event.target.value;
                        let bottle_thirdline = new CircleType(_.preview.thirdline_curve_text_preview);
                        bottle_thirdline.dir(-1).radius(188);   
                        bottle_thirdline.forceHeight(false); 
                        bottle_thirdline.forceWidth(false);   
                        bottle_thirdline.refresh();   
                    } 
                    if(_.preview.magic360_thirdline_curve_text_preview) {
                        _.preview.magic360_thirdline_curve_text_preview.innerHTML = event.target.value;                   
                        let bottle_thirdline = new CircleType(_.preview.magic360_thirdline_curve_text_preview);
                        bottle_thirdline.dir(-1).radius(290);          
                        bottle_thirdline.forceHeight(false);  
                        bottle_thirdline.forceWidth(false);    
                        bottle_thirdline.refresh();   
                    }
                    if(_.preview.mobile_thirdline_curve_text_preview) {
                        _.preview.mobile_thirdline_curve_text_preview.innerHTML = event.target.value;
                        let mobile_bottle_thirdline = new CircleType(_.preview.mobile_thirdline_curve_text_preview);
                        mobile_bottle_thirdline.dir(-1).radius(218);  
                        mobile_bottle_thirdline.forceHeight(false);  
                        mobile_bottle_thirdline.forceWidth(false); 
                        mobile_bottle_thirdline.refresh();   
                    }                               
                } 
                if(_.input.bottle_term_sales.checked && _.input.bottle_firstline.value !== '' || _.input.bottle_term_sales.checked && _.input.bottle_secondline.value !== '' || _.input.bottle_term_sales.checked && _.input.bottle_thirdline.value !== '') {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                    if(_.btn.mobile_add_to_cart.length>0) {
                     _.btn.mobile_add_to_cart.forEach(el => {
                          el.removeAttribute('disabled');
                          el.addEventListener('click', event => {
                              _.closemaker(event);
                          })
                     })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                             _.btn.product_edit_engrave.forEach(el => {
                                 el.removeAttribute('disabled');
                                 el.addEventListener('click', event => {
                                    _.closemaker(event);
                                })
                             })
                     }
                 }  else {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                    if(_.btn.mobile_add_to_cart.length>0) {
                        _.btn.mobile_add_to_cart.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                             el.setAttribute('disabled','');
                        })                         
                    }
                 } 
            })
            _.input.bottle_thirdline.addEventListener('focus', (event) => {
            _.label.bottle_thirdline.classList.add('focus');
            if(_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();   
            if(_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();            
            if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.add('active');
                _.preview.secondline_curve_preview.classList.remove('active');               
                _.preview.secondline_straight_preview.classList.add('active');
                _.preview.thirdline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.add('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.add('active');
                _.preview.mobile_thirdline_curve_preview.classList.remove('active');
            }     
            if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                if(_.preview.firstline_curve_preview)_.preview.firstline_curve_preview.classList.add('active');
                if(_.preview.firstline_straight_preview)_.preview.firstline_straight_preview.classList.remove('active');
                if(_.preview.secondline_curve_preview)_.preview.secondline_curve_preview.classList.add('active');              
                if(_.preview.secondline_straight_preview)_.preview.secondline_straight_preview.classList.remove('active');
                if(_.preview.thirdline_curve_preview)_.preview.secondline_curve_preview.classList.add('active');
                if(_.preview.mobile_firstline_curve_preview)_.preview.mobile_firstline_curve_preview.classList.add('active');
                if(_.preview.mobile_firstline_straight_preview)_.preview.mobile_firstline_straight_preview.classList.remove('active');
                if(_.preview.mobile_secondline_curve_preview)_.preview.mobile_secondline_curve_preview.classList.add('active');
                if(_.preview.mobile_secondline_straight_preview)_.preview.mobile_secondline_straight_preview.classList.remove('active');
                if(_.preview.mobile_thirdline_curve_preview)_.preview.mobile_thirdline_curve_preview.classList.add('active');
                if(_.preview.magic360_firstline_curve_preview)_.preview.magic360_firstline_curve_preview.classList.add('active');
                if(_.preview.magic360_secondline_curve_preview)_.preview.magic360_secondline_curve_preview.classList.add('active');
                if(_.preview.magic360_thirdline_curve_preview)_.preview.magic360_thirdline_curve_preview.classList.add('active');
            }     
         })
           _.input.bottle_thirdline.addEventListener('focusout', (event) => {
                 if(event.target.value === '') {
                     _.label.bottle_thirdline.classList.remove('focus');
                 }           
             })
         }  
         if(_.input.glass_firstline) {
            _.input.glass_firstline.addEventListener('keyup', (event) => {
                let remaining_char = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length);
                if(remaining_char >= 0) {
                    event.target.nextElementSibling.innerHTML = remaining_char + ' ' + event.target.getAttribute('data-text-remaining');   
                } else {
                    const input_value = event.target.value;
                    const newValue = input_value.slice(0, -1);
                    event.target.value = newValue;
                }                   
                if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                    if( _.preview.firstline_straight_text_preview)_.preview.firstline_straight_text_preview.innerHTML = event.target.value;
                    if(_.preview.mobile_firstline_straight_text_preview)_.preview.mobile_firstline_straight_text_preview.innerHTML = event.target.value;
                }     
                if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                    if(_.preview.firstline_curve_text_preview) {
                        _.preview.firstline_curve_text_preview.innerHTML = event.target.value;
                        let glass_firstline = new CircleType(_.preview.firstline_curve_text_preview);
                        glass_firstline.dir(-1).radius(138);  
                        glass_firstline.forceHeight(false); 
                        glass_firstline.forceWidth(false);      
                        glass_firstline.refresh();  
                    }
                    if(_.preview.mobile_firstline_curve_text_preview) {
                        _.preview.mobile_firstline_curve_text_preview.innerHTML = event.target.value;                  
                        let mobile_glass_firstline = new CircleType(_.preview.mobile_firstline_curve_text_preview);
                        mobile_glass_firstline.dir(-1).radius(138);   
                        mobile_glass_firstline.forceHeight(false);  
                        mobile_glass_firstline.forceWidth(false); 
                        glass_firstline.refresh();           
                    }                 
                }    
                if(_.input.glass_term_sales.checked && _.input.glass_firstline.value !== '' || _.input.glass_term_sales.checked && _.input.glass_secondline.value !== '') {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                    if(_.btn.mobile_add_to_cart.length>0) {
                     _.btn.mobile_add_to_cart.forEach(el => {
                          el.removeAttribute('disabled');
                          el.addEventListener('click', event => {
                              _.closemaker(event);
                          })
                     })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                             _.btn.product_edit_engrave.forEach(el => {
                                 el.removeAttribute('disabled');
                                 el.addEventListener('click', event => {
                                    _.closemaker(event);
                                })
                             })
                     }
                 }  else {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                    if(_.btn.mobile_add_to_cart.length>0) {
                        _.btn.mobile_add_to_cart.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                        _.btn.product_edit_engrave.forEach(el => {
                            el.setAttribute('disabled','');
                        })
                    }
                 }                
            })
            _.input.glass_firstline.addEventListener('focus', (event) => {
            _.label.glass_firstline.classList.add('focus');
            event.target.style.setProperty('background-color','#fff');
           if(_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))]) _.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();   
           if(_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();            
            if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.add('active');
                _.preview.secondline_curve_preview.classList.remove('active');
                _.preview.secondline_straight_preview.classList.remove('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.add('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.remove('active');
            }     
            if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                _.preview.firstline_curve_preview.classList.add('active');
                _.preview.firstline_straight_preview.classList.remove('active');
                _.preview.secondline_curve_preview.classList.remove('active');
                _.preview.secondline_straight_preview.classList.remove('active');
                _.preview.mobile_firstline_curve_preview.classList.add('active');
                _.preview.mobile_firstline_straight_preview.classList.remove('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.remove('active');
            }     
         })
           _.input.glass_firstline.addEventListener('focusout', (event) => {
                 if(event.target.value === '') {
                     _.label.glass_firstline.classList.remove('focus');                   
                 }           
             })
         }  
         if(_.input.glass_secondline) {
            _.input.glass_secondline.addEventListener('keyup', (event) => {
                let remaining_char = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length);
                if(remaining_char >= 0) {
                    event.target.nextElementSibling.innerHTML = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length) + ' ' + event.target.getAttribute('data-text-remaining');
                } else {
                    const input_value = event.target.value;
                    const newValue = input_value.slice(0, -1);
                    event.target.value = newValue;
                }
                 if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                    if(_.preview.secondline_straight_text_preview)_.preview.secondline_straight_text_preview.innerHTML = event.target.value;
                    if(_.preview.mobile_secondline_straight_text_preview)_.preview.mobile_secondline_straight_text_preview.innerHTML = event.target.value;
                }     
                if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                    if(_.preview.secondline_curve_text_preview) {
                        _.preview.secondline_curve_text_preview.innerHTML = event.target.value;
                        let glass_secondline = new CircleType(_.preview.secondline_curve_text_preview);
                        glass_secondline.dir(-1).radius(348);
                        glass_secondline.forceHeight(false);  
                        glass_secondline.forceWidth(false);  
                        glass_secondline.refresh();     
                    }
                    if(_.preview.mobile_secondline_curve_text_preview) {
                        _.preview.mobile_secondline_curve_text_preview.innerHTML = event.target.value;                  
                        let mobile_glass_secondline = new CircleType(_.preview.mobile_secondline_curve_text_preview);
                        mobile_glass_secondline.dir(-1).radius(348);       
                        mobile_glass_secondline.forceHeight(false);  
                        mobile_glass_secondline.forceWidth(false);  
                        mobile_glass_secondline.refresh();      
                    }                       
                }  
                if(_.input.glass_term_sales.checked && _.input.glass_secondline.value !== '' || _.input.glass_term_sales.checked && _.input.glass_firstline.value !== '') {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                    if(_.btn.mobile_add_to_cart.length>0) {
                     _.btn.mobile_add_to_cart.forEach(el => {
                          el.removeAttribute('disabled');
                          el.addEventListener('click', event => {
                              _.closemaker(event);
                          })
                     })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                             _.btn.product_edit_engrave.forEach(el => {
                                 el.removeAttribute('disabled');
                                 el.addEventListener('click', event => {
                                    _.closemaker(event);
                                 })
                             })
                     }
                 }  else {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                    if(_.btn.mobile_add_to_cart.length>0) {
                        _.btn.mobile_add_to_cart.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                 }                  
            })
            _.input.glass_secondline.addEventListener('focus', (event) => {
            _.label.glass_secondline.classList.add('focus');
            event.target.style.setProperty('background-color','#fff');
            if(_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();     
            if(_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();         
            if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.remove('active');
                _.preview.secondline_curve_preview.classList.remove('active');
                _.preview.secondline_straight_preview.classList.add('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.remove('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.add('active');
            }     
            if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.remove('active');
                _.preview.secondline_curve_preview.classList.add('active');
                _.preview.secondline_straight_preview.classList.remove('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.remove('active');
                _.preview.mobile_secondline_curve_preview.classList.add('active');
                _.preview.mobile_secondline_straight_preview.classList.remove('active');
            }           
         })
           _.input.glass_secondline.addEventListener('focusout', (event) => {
                 if(event.target.value === '') {
                     _.label.glass_secondline.classList.remove('focus');
                 }           
             })
         }  
         if(_.btn.product_page_glass_prev) {
             _.btn.product_page_glass_prev.addEventListener('click', (event) => {
                 _.selector.product_custom_engrave_glass_firstline.classList.remove('d-none');
                 _.selector.product_custom_engrave_glass_secondline.classList.add('d-none');
                 _.label.toggle_glass_label.innerHTML = 'Glass 1/2';
                 _.label.toggle_glass_mobile_label.innerHTML = 'Glass 1/2';
                 event.target.closest('button').classList.add('active');
                 _.btn.product_page_glass_next.classList.remove('active');
                 _.btn.product_page_glass_bullet_next.classList.remove('active');
                 _.btn.product_page_glass_bullet_prev.classList.add('active');
             })
         }
         if(_.btn.product_page_glass_bullet_prev) {
            _.btn.product_page_glass_bullet_prev.addEventListener('click', (event) => {
                _.selector.product_custom_engrave_glass_firstline.classList.remove('d-none');
                _.selector.product_custom_engrave_glass_secondline.classList.add('d-none');
                _.label.toggle_glass_label.innerHTML = 'Glass 1/2';
                _.label.toggle_glass_mobile_label.innerHTML = 'Glass 1/2';
                _.btn.product_page_glass_prev.classList.add('active');
                _.btn.product_page_glass_next.classList.remove('active');
                event.target.closest('li').classList.add('active');
                _.btn.product_page_glass_bullet_next.classList.remove('active');
            })
        }
         if(_.btn.product_page_glass_next) {
            _.btn.product_page_glass_next.addEventListener('click', (event) => {
                _.selector.product_custom_engrave_glass_firstline.classList.add('d-none');
                _.selector.product_custom_engrave_glass_secondline.classList.remove('d-none');
                _.label.toggle_glass_label.innerHTML = 'Glass 2/2';
                _.label.toggle_glass_mobile_label.innerHTML = 'Glass 2/2';
                event.target.closest('button').classList.add('active');
                _.btn.product_page_glass_prev.classList.remove('active');
                _.btn.product_page_glass_bullet_next.classList.add('active');
                _.btn.product_page_glass_bullet_prev.classList.remove('active');
            })
         }
         if(_.btn.product_page_glass_bullet_next) {
            _.btn.product_page_glass_bullet_next.addEventListener('click', (event) => {
                _.selector.product_custom_engrave_glass_firstline.classList.add('d-none');
                _.selector.product_custom_engrave_glass_secondline.classList.remove('d-none');
                _.label.toggle_glass_label.innerHTML = 'Glass 2/2';
                _.label.toggle_glass_mobile_label.innerHTML = 'Glass 2/2';
                event.target.closest('li').classList.add('active');
                _.btn.product_page_glass_bullet_prev.classList.remove('active');
                _.btn.product_page_glass_prev.classList.remove('active');
                _.btn.product_page_glass_next.classList.add('active');
            })
         }
         if(_.input.drop_firstline) {
            _.input.drop_firstline.addEventListener('keyup', (event) => {
                let remaining_char = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length);
                if(remaining_char >= 0) {
                    event.target.nextElementSibling.innerHTML = remaining_char + ' ' + event.target.getAttribute('data-text-remaining');   
                } else {
                    const input_value = event.target.value;
                    const newValue = input_value.slice(0, -1);
                    event.target.value = newValue;
                }                   
                if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                    if( _.preview.firstline_straight_text_preview)_.preview.firstline_straight_text_preview.innerHTML = event.target.value;
                    if(_.preview.mobile_firstline_straight_text_preview)_.preview.mobile_firstline_straight_text_preview.innerHTML = event.target.value;
                }     
                if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                    if(_.preview.firstline_curve_text_preview) {
                        _.preview.firstline_curve_text_preview.innerHTML = event.target.value;
                        let drop_firstline = new CircleType(_.preview.firstline_curve_text_preview);
                        drop_firstline.dir(-1).radius(138);  
                        drop_firstline.forceHeight(false); 
                        drop_firstline.forceWidth(false);      
                        drop_firstline.refresh();  
                    }
                    if(_.preview.mobile_firstline_curve_text_preview) {
                        _.preview.mobile_firstline_curve_text_preview.innerHTML = event.target.value;                  
                        let mobile_drop_firstline = new CircleType(_.preview.mobile_firstline_curve_text_preview);
                        mobile_drop_firstline.dir(-1).radius(138);   
                        mobile_drop_firstline.forceHeight(false);  
                        mobile_drop_firstline.forceWidth(false); 
                        drop_firstline.refresh();           
                    }                 
                }    
                if(_.input.drop_term_sales.checked && _.input.dropfirstline.value !== '' || _.input.drop_term_sales.checked && _.input.drop_secondline.value !== '') {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                    if(_.btn.mobile_add_to_cart.length>0) {
                     _.btn.mobile_add_to_cart.forEach(el => {
                          el.removeAttribute('disabled');
                          el.addEventListener('click', event => {
                              _.closemaker(event);
                          })
                     })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                             _.btn.product_edit_engrave.forEach(el => {
                                 el.removeAttribute('disabled');
                                 el.addEventListener('click', event => {
                                    _.closemaker(event);
                                })
                             })
                     }
                 }  else {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                    if(_.btn.mobile_add_to_cart.length>0) {
                        _.btn.mobile_add_to_cart.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                        _.btn.product_edit_engrave.forEach(el => {
                            el.setAttribute('disabled','');
                        })
                    }
                 }                
            })
            _.input.drop_firstline.addEventListener('focus', (event) => {
            _.label.drop_firstline.classList.add('focus');
            event.target.style.setProperty('background-color','#fff');
           if(_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))]) _.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();   
           if(_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();            
            if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.add('active');
                _.preview.secondline_curve_preview.classList.remove('active');
                _.preview.secondline_straight_preview.classList.remove('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.add('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.remove('active');
            }     
            if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                _.preview.firstline_curve_preview.classList.add('active');
                _.preview.firstline_straight_preview.classList.remove('active');
                _.preview.secondline_curve_preview.classList.remove('active');
                _.preview.secondline_straight_preview.classList.remove('active');
                _.preview.mobile_firstline_curve_preview.classList.add('active');
                _.preview.mobile_firstline_straight_preview.classList.remove('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.remove('active');
            }     
         })
           _.input.drop_firstline.addEventListener('focusout', (event) => {
                 if(event.target.value === '') {
                     _.label.drop_firstline.classList.remove('focus');                   
                 }           
             })
         }
         if(_.input.drop_secondline) {
            _.input.drop_secondline.addEventListener('keyup', (event) => {
                let remaining_char = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length);
                if(remaining_char >= 0) {
                    event.target.nextElementSibling.innerHTML = Number(event.target.getAttribute('maxlength')) - Number(event.target.value.length) + ' ' + event.target.getAttribute('data-text-remaining');
                } else {
                    const input_value = event.target.value;
                    const newValue = input_value.slice(0, -1);
                    event.target.value = newValue;
                }
                 if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                    if(_.preview.secondline_straight_text_preview)_.preview.secondline_straight_text_preview.innerHTML = event.target.value;
                    if(_.preview.mobile_secondline_straight_text_preview)_.preview.mobile_secondline_straight_text_preview.innerHTML = event.target.value;
                }     
                if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                    if(_.preview.secondline_curve_text_preview) {
                        _.preview.secondline_curve_text_preview.innerHTML = event.target.value;
                        let drop_secondline = new CircleType(_.preview.secondline_curve_text_preview);
                        drop_secondline.dir(-1).radius(348);
                        drop_secondline.forceHeight(false);  
                        drop_secondline.forceWidth(false);  
                        drop_secondline.refresh();     
                    }
                    if(_.preview.mobile_secondline_curve_text_preview) {
                        _.preview.mobile_secondline_curve_text_preview.innerHTML = event.target.value;                  
                        let mobile_drop_secondline = new CircleType(_.preview.mobile_secondline_curve_text_preview);
                        mobile_drop_secondline.dir(-1).radius(348);       
                        mobile_drop_secondline.forceHeight(false);  
                        mobile_drop_secondline.forceWidth(false);  
                        mobile_drop_secondline.refresh();      
                    }                       
                }  
                if(_.input.drop_term_sales.checked && _.input.drop_secondline.value !== '' || _.input.drop_term_sales.checked && _.input.drop_firstline.value !== '') {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                    if(_.btn.mobile_add_to_cart.length>0) {
                     _.btn.mobile_add_to_cart.forEach(el => {
                          el.removeAttribute('disabled');
                          el.addEventListener('click', event => {
                              _.closemaker(event);
                          })
                     })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                             _.btn.product_edit_engrave.forEach(el => {
                                 el.removeAttribute('disabled');
                                 el.addEventListener('click', event => {
                                    _.closemaker(event);
                                 })
                             })
                     }
                 }  else {
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                    if(_.btn.mobile_add_to_cart.length>0) {
                        _.btn.mobile_add_to_cart.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                     if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                             el.setAttribute('disabled','');
                        })
                     }
                 }                  
            })
            _.input.drop_secondline.addEventListener('focus', (event) => {
            _.label.drop_secondline.classList.add('focus');
            event.target.style.setProperty('background-color','#fff');
            if(_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();     
            if(_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))])_.preview.magic360_thumbnails_slider[Number(event.target.getAttribute('data-line-preview-position'))].click();         
            if(event.target.getAttribute('data-line-preview-shape') === 'straight') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.remove('active');
                _.preview.secondline_curve_preview.classList.remove('active');
                _.preview.secondline_straight_preview.classList.add('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.remove('active');
                _.preview.mobile_secondline_curve_preview.classList.remove('active');
                _.preview.mobile_secondline_straight_preview.classList.add('active');
            }     
            if(event.target.getAttribute('data-line-preview-shape') === 'curve') {
                _.preview.firstline_curve_preview.classList.remove('active');
                _.preview.firstline_straight_preview.classList.remove('active');
                _.preview.secondline_curve_preview.classList.add('active');
                _.preview.secondline_straight_preview.classList.remove('active');
                _.preview.mobile_firstline_curve_preview.classList.remove('active');
                _.preview.mobile_firstline_straight_preview.classList.remove('active');
                _.preview.mobile_secondline_curve_preview.classList.add('active');
                _.preview.mobile_secondline_straight_preview.classList.remove('active');
            }           
         })
           _.input.drop_secondline.addEventListener('focusout', (event) => {
                 if(event.target.value === '') {
                     _.label.drop_secondline.classList.remove('focus');
                 }           
             })
         }  
         if(_.input.glass_term_sales) {
            _.input.glass_term_sales.addEventListener('click', (event) => {                
                if(event.target.checked && _.input.glass_firstline.value !== '' || event.target.checked && _.input.glass_secondline.value !== '') {
                   if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                   if(_.btn.mobile_add_to_cart.length>0) {
                    _.btn.mobile_add_to_cart.forEach(el => {
                         el.removeAttribute('disabled');
                         el.addEventListener('click', event => {
                             _.closemaker(event);
                         })
                    })
                    }
                    if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                                el.removeAttribute('disabled');
                                el.addEventListener('click', event => {
                                    _.closemaker(event);
                                })
                            })
                    }
                }  else {
                   if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                   if(_.btn.mobile_add_to_cart.length>0) {
                       _.btn.mobile_add_to_cart.forEach(el => {
                            el.setAttribute('disabled','');
                       })
                    }
                    if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                                el.setAttribute('disabled','');
                            })
                    }
                }               
            })      
         }
         if(_.input.bottle_term_sales) {
            _.input.bottle_term_sales.addEventListener('click', (event) => {
                if(event.target.checked && _.input.bottle_firstline.value !== '' || event.target.checked && _.input.bottle_secondline.value !== '' || event.target.checked && _.input.bottle_thirdline.value !== '') {
                   if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                   if(_.btn.mobile_add_to_cart.length>0) {
                    _.btn.mobile_add_to_cart.forEach(el => {
                         el.removeAttribute('disabled');
                         el.addEventListener('click', event => {
                            _.closemaker(event);
                        })
                    })                 
                    }
                    if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                                el.removeAttribute('disabled');
                                el.addEventListener('click', event => {
                                    _.closemaker(event);
                                })
                            })
                    }
                }  else {
                   if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                   if(_.btn.mobile_add_to_cart.length>0) {
                    _.btn.mobile_add_to_cart.forEach(el => {
                         el.setAttribute('disabled','');
                    })
                   }
                    _.btn.product_edit_engrave.forEach(el => {
                        el.setAttribute('disabled','');
                    })
                }               
            })      
         }
         if(_.input.drop_term_sales) {
            _.input.drop_term_sales.addEventListener('click', (event) => {                
                if(event.target.checked && _.input.drop_firstline.value !== '' || event.target.checked && _.input.drop_secondline.value !== '') {
                   if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.removeAttribute('disabled');
                   if(_.btn.mobile_add_to_cart.length>0) {
                    _.btn.mobile_add_to_cart.forEach(el => {
                         el.removeAttribute('disabled');
                         el.addEventListener('click', event => {
                             _.closemaker(event);
                         })
                    })
                    }
                    if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                                el.removeAttribute('disabled');
                                el.addEventListener('click', event => {
                                    _.closemaker(event);
                                })
                            })
                    }
                }  else {
                   if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.setAttribute('disabled','');
                   if(_.btn.mobile_add_to_cart.length>0) {
                       _.btn.mobile_add_to_cart.forEach(el => {
                            el.setAttribute('disabled','');
                       })
                    }
                    if(_.btn.product_edit_engrave.length>0) {
                            _.btn.product_edit_engrave.forEach(el => {
                                el.setAttribute('disabled','');
                            })
                    }
                }               
            })      
         }
         if(_.preview.product_thumbnails) {
             _.preview.product_thumbnails.addEventListener('click',() => {
                 _.preview.firstline_curve_preview.classList.remove('active');
                 _.preview.firstline_straight_preview.classList.remove('active');
                 _.preview.secondline_curve_preview.classList.remove('active');
                 _.preview.secondline_straight_preview.classList.remove('active');
             })
         }
         if(window.matchMedia('(max-width: 48rem)').matches && _.label.header_glass_label) {
             _.label.header_glass_label.innerHTML = 'Engrave';   
         } else {
             if(_.label.header_glass_label)_.label.header_glass_label.innerHTML = 'Cancel';    
         }
         if(window.matchMedia('(max-width: 48rem)').matches && _.label.header_bottle_label) {
            _.label.header_bottle_label.innerHTML = 'Engrave';   
         } else {
           if( _.label.header_bottle_label) _.label.header_bottle_label.innerHTML = 'Cancel';    
         }
         if(window.matchMedia('(max-width: 48rem)').matches && _.label.header_drop_label) {
            _.label.header_drop_label.innerHTML = 'Engrave';   
         } else {
            if(_.label.header_drop_label)_.label.header_drop_label.innerHTML = 'Cancel';    
         }
         window.addEventListener('resize', function(event) {
            if(window.matchMedia('(max-width: 48rem)').matches && _.label.header_glass_label) {
                _.label.header_glass_label.innerHTML = 'Engrave';  
            } else {
                 if(_.label.header_glass_label) _.label.header_glass_label.innerHTML = 'Cancel';    
            }
         }, true);
         window.addEventListener('resize', function(event) {
            if(window.matchMedia('(max-width: 48rem)').matches && _.label.header_bottle_label) {
                if(_.label.header_bottle_label)_.label.header_bottle_label.innerHTML = 'Engrave';  
            } else {
                 if(_.label.header_bottle_label) _.label.header_bottle_label.innerHTML = 'Cancel';    
            }
         }, true);
         window.addEventListener('resize', function(event) {
            if(window.matchMedia('(max-width: 48rem)').matches && _.label.header_drop_label) {
                _.label.header_drop_label.innerHTML = 'Engrave';  
            } else {
                 if(_.label.header_drop_label) _.label.header_drop_label.innerHTML = 'Cancel';    
            }
         }, true);
         if(_.getjsonproperty('customengravingjson') !== 'close') {
             _.editmode(_.getjsonproperty('customengravingjson'));
         } else {
             if(_.btn.mobile_add_to_cart.length>0) {
                _.btn.mobile_add_to_cart.forEach(el => {
                    el.classList.remove('d-none');
                })
                _.btn.product_page_add_to_cart.classList.remove('d-none');
             }
             if(_.input.bottle_firstline)_.input.bottle_firstline.value = '';
             if(_.input.bottle_secondline)_.input.bottle_secondline.value = '';
             if(_.input.bottle_thirdline)_.input.bottle_secondline.value = '';
             if(_.input.glass_firstline)_.input.glass_firstline.value = '';
             if(_.input.glass_secondline)_.input.glass_secondline.value = '';
             if(_.input.drop_firstline)_.input.drop_firstline.value = '';
             if(_.input.drop_secondline)_.input.drop_secondline.value = '';
             if(_.btn.product_edit_engrave.length>0) {
                _.btn.product_edit_engrave.forEach(el => {
                    el.classList.add('d-none');
                })
                _.btn.product_page_add_to_cart.classList.remove('d-none');
             }
         }    
        if(_.preview.product_magic360_thumbnails) {
            _.preview.product_magic360_thumbnails.addEventListener('click',() => {
                _.preview.magic360_firstline_curve_preview.classList.remove('active');
                _.preview.magic360_secondline_curve_preview.classList.remove('active');
                _.preview.magic360_thirdline_curve_preview.classList.remove('active');
            })
        }
    }
    customEngraving.prototype.openmaker = function(event) {
        var _ = this; 
        if(event.target.closest('button').classList.contains('engraving-bottle-button')) {
            event.target.closest('button').classList.add('d-none');
            _.selector.product_custom_engrave_bottle.classList.add('active');
        }
        if(event.target.closest('button').classList.contains('engraving-glass-button')) {
            event.target.closest('button').classList.add('d-none');
            _.selector.product_custom_engrave_glass.classList.add('active');
        }
        if(event.target.closest('button').classList.contains('engraving-drop-button')) {
            event.target.closest('button').classList.add('d-none');
            _.selector.product_custom_engrave_drop.classList.add('active');
        }
        if(_.btn.product_page_add_to_cart) {
            _.btn.product_page_add_to_cart.setAttribute('disabled','');
        }    
        if(_.preview.mobile_bottle) {
            _.preview.mobile_bottle.classList.add('active');
        }    
        if(_.preview.mobile_glass) {
            _.preview.mobile_glass.classList.add('active');
        }    
        if(_.preview.mobile_drop) {
            _.preview.mobile_drop.classList.add('active');
        }    
        if(window.matchMedia('(max-width: 48rem)').matches) {
            let scrollPosition = window.pageYOffset;
            document.body.style.setProperty('padding-right', '6px');
            document.body.style.setProperty('overflow', 'hidden');   
            document.body.style.setProperty('position', 'fixed');  
            document.body.style.setProperty('top', `-${scrollPosition}px`);  
            document.body.style.setProperty('width', '100%');  
        } else {
            document.body.style.removeProperty('padding-right');
            document.body.style.removeProperty('overflow');   
            document.body.style.removeProperty('position');  
            document.body.style.removeProperty('top');  
            document.body.style.removeProperty('width');  
        }
    }
    customEngraving.prototype.closemaker = function(event) {
        var _ = this; 
        if(event.target.closest('button').classList.contains('engraving-bottle')) {
            _.selector.product_custom_engrave_bottle.classList.remove('active');
            _.btn.product_page_bottle.classList.remove('d-none');
        }
        if(event.target.closest('button').classList.contains('engraving-glass')) {
            _.selector.product_custom_engrave_glass.classList.remove('active');
            _.btn.product_page_glass.classList.remove('d-none');
        }
        if(event.target.closest('button').classList.contains('engraving-drop')) {
            _.selector.product_custom_engrave_drop.classList.remove('active');
            _.btn.product_page_drop.classList.remove('d-none');
        }
        if(_.btn.product_page_add_to_cart) {
            _.btn.product_page_add_to_cart.removeAttribute('disabled');
        }
        if(_.preview.mobile_bottle) {
            _.preview.mobile_bottle.classList.remove('active');
        }    
        if(_.preview.mobile_glass) {
            _.preview.mobile_glass.classList.remove('active');
        }
        if(_.preview.mobile_drop) {
            _.preview.mobile_drop.classList.remove('active');
        }
        if(window.matchMedia('(max-width: 48rem)').matches) {
            document.body.style.removeProperty('padding-right');
            document.body.style.removeProperty('overflow');   
            document.body.style.removeProperty('position');  
            document.body.style.removeProperty('top');  
            document.body.style.removeProperty('width');  
        }
        if(_.btn.product_edit_engrave.length>0) {
            _.btn.product_edit_engrave.forEach(el => {
                el.classList.add('d-none');
            })
        }
        if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.classList.remove('d-none');
        _.setjsonproperty('close');
        if(_.input.glass_firstline) {
            _.input.glass_firstline.value = '';
            _.input.glass_firstline.nextElementSibling.innerHTML = Number(_.input.glass_firstline.getAttribute('maxlength')) - Number(_.input.glass_firstline.value.length) + ' ' + _.input.glass_firstline.getAttribute('data-text-remaining');
        }
        if(_.input.glass_secondline) {
            _.input.glass_secondline.value = '';
            _.input.glass_secondline.nextElementSibling.innerHTML = Number(_.input.glass_secondline.getAttribute('maxlength')) - Number(_.input.glass_secondline.value.length) + ' ' + _.input.glass_secondline.getAttribute('data-text-remaining');
        }
        if(_.input.drop_firstline) {
            _.input.drop_firstline.value = '';
            _.input.drop_firstline.nextElementSibling.innerHTML = Number(_.input.drop_firstline.getAttribute('maxlength')) - Number(_.input.drop_firstline.value.length) + ' ' + _.input.drop_firstline.getAttribute('data-text-remaining');
        }
        if(_.input.drop_secondline) {
            _.input.drop_secondline.value = '';
            _.input.drop_secondline.nextElementSibling.innerHTML = Number(_.input.drop_secondline.getAttribute('maxlength')) - Number(_.input.drop_secondline.value.length) + ' ' + _.input.drop_secondline.getAttribute('data-text-remaining');
        }
        if(_.input.bottle_firstline) {
            _.input.bottle_firstline.value = '';
            _.input.bottle_firstline.nextElementSibling.innerHTML = Number(_.input.bottle_firstline.getAttribute('maxlength')) - Number(_.input.bottle_firstline.value.length) + ' ' + _.input.bottle_firstline.getAttribute('data-text-remaining');
        }
        if(_.input.bottle_secondline) {
            _.input.bottle_secondline.value = '';
            _.input.bottle_secondline.nextElementSibling.innerHTML = Number(_.input.bottle_secondline.getAttribute('maxlength')) - Number(_.input.bottle_secondline.value.length) + ' ' + _.input.bottle_secondline.getAttribute('data-text-remaining');
        }
        if(_.input.bottle_thirdline) {
            _.input.bottle_thirdline.value = '';
            _.input.bottle_thirdline.nextElementSibling.innerHTML = Number(_.input.bottle_thirdline.getAttribute('maxlength')) - Number(_.input.bottle_thirdline.value.length) + ' ' + _.input.bottle_thirdline.getAttribute('data-text-remaining');
        }
        if(_.preview.firstline_curve_text_preview) {
            _.preview.firstline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.secondline_curve_text_preview) {
            _.preview.secondline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.thirdline_curve_text_preview) {
            _.preview.thirdline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.firstline_straight_text_preview) {
            _.preview.firstline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.secondline_straight_text_preview) {
            _.preview.secondline_straight_text_preview.innerHTML = '';
        }
        if(_.preview.mobile_firstline_curve_text_preview) {
            _.preview.mobile_firstline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.mobile_secondline_curve_text_preview) {
            _.preview.mobile_secondline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.mobile_thirdline_curve_text_preview) {
            _.preview.mobile_thirdline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.mobile_firstline_straight_text_preview) {
            _.preview.mobile_firstline_straight_text_preview.innerHTML = '';
        }
        if(_.preview.mobile_secondline_straight_text_preview) {
            _.preview.mobile_secondline_straight_text_preview.innerHTML = '';
        }
        if(_.preview.magic360_firstline_curve_text_preview) {
            _.preview.magic360_firstline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.magic360_secondline_curve_text_preview) {
            _.preview.magic360_secondline_curve_text_preview.innerHTML = '';
        }
        if(_.preview.magic360_thirdline_curve_text_preview) {
            _.preview.magic360_thirdline_curve_text_preview.innerHTML = '';
        }
        if(_.input.bottle_term_sales) {
            _.input.bottle_term_sales.checked = false;
        }
        if(_.input.glass_term_sales) {
            _.input.glass_term_sales.checked = false;
        }   
        if(_.input.drop_term_sales) {
            _.input.drop_term_sales.checked = false;
        }
        if(_.preview.firstline_curve_preview)_.preview.firstline_curve_preview.classList.remove('active');
        if(_.preview.firstline_straight_preview)_.preview.firstline_straight_preview.classList.remove('active');
        if(_.preview.secondline_curve_preview)_.preview.secondline_curve_preview.classList.remove('active');
        if(_.preview.secondline_straight_preview)_.preview.secondline_straight_preview.classList.remove('active');
        if(_.preview.thirdline_curve_preview)_.preview.thirdline_curve_preview.classList.remove('active');
        if(_.preview.mobile_firstline_curve_preview)_.preview.mobile_firstline_curve_preview.classList.remove('active');
        if(_.preview.mobile_firstline_straight_preview)_.preview.mobile_firstline_straight_preview.classList.remove('active');
        if(_.preview.mobile_secondline_curve_preview)_.preview.mobile_secondline_curve_preview.classList.remove('active');
        if(_.preview.mobile_secondline_straight_preview)_.preview.mobile_secondline_straight_preview.classList.remove('active');
        if(_.preview.mobile_thirdline_curve_preview)_.preview.mobile_thirdline_curve_preview.classList.remove('active');
        if(_.preview.magic360_firstline_curve_preview)_.preview.magic360_firstline_curve_preview.classList.remove('active');
        if(_.preview.magic360_secondline_curve_preview)_.preview.magic360_secondline_curve_preview.classList.remove('active');     
        if(_.preview.magic360_thirdline_curve_preview)_.preview.magic360_thirdline_curve_preview.classList.remove('active');     
    }
    customEngraving.prototype.setjsonproperty = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'customengravingjson' + "=" + cvalue + ";" + expires + ";path=/";
    }
    customEngraving.prototype.getjsonproperty = function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "close";
    }
    customEngraving.prototype.editmode = function(json) {
        var _ = this;
        let jsonedit = JSON.parse(json);
        if(_.btn.mobile_add_to_cart.length>0) {
            _.btn.mobile_add_to_cart.forEach(el => {
                el.classList.add('d-none');
            })
        }
        if(_.selector.product_custom_engrave_bottle) {
            if(_.selector.product_custom_engrave_bottle.getAttribute('data-product-default-handle') === jsonedit.editengrave.handle) {
                window.addEventListener('DOMContentLoaded', (event) => {
                    _.selector.product_custom_engrave_bottle.setAttribute('data-item-key',jsonedit.editengrave.line);
                    if(_.input.bottle_firstline) _.input.bottle_firstline.value = jsonedit.editengrave.firstline;
                    if(_.label.bottle_firstline) _.label.bottle_firstline.classList.add('focus');
                    if( _.input.bottle_secondline) _.input.bottle_secondline.value = jsonedit.editengrave.secondline;
                    if( _.label.bottle_secondline) _.label.bottle_secondline.classList.add('focus');
                    if( _.input.bottle_thirdline) _.input.bottle_thirdline.value = jsonedit.editengrave.thirdline;
                    if( _.label.bottle_thirdline) _.label.bottle_thirdline.classList.add('focus');
                    if(_.btn.product_page_add_to_cart)_.btn.product_page_add_to_cart.classList.add('d-none');
                    if(_.btn.product_edit_engrave)_.btn.product_edit_engrave.forEach(el => {
                        el.classList.remove('d-none');
                        el.addEventListener('click', (event) => {                          
                           theme.cartAddItem.engravingpropertyupdate(_.selector.product_custom_engrave_bottle.getAttribute('data-item-key'),_.input.bottle_firstline.value,_.input.bottle_secondline.value, _.input.bottle_thirdline.value);
                           if(_.btn.product_page_glass_close) _.btn.product_page_glass_close.click();
                           if(_.input.bottle_firstline) _.input.bottle_firstline.value = '';
                           if(_.input.bottle_secondline) _.input.bottle_secondline.value ='';
                           if(_.input.bottle_thirdline) _.input.bottle_thirdline.value ='';
                           if(_.input.glass_firstline) _.input.glass_firstline.value = '';
                           if(_.input.glass_secondline) _.input.glass_secondline.value = '';
                        })
                    })                    
                    _.btn.product_page_bottle.click();
                });             
            }
        }
        if(_.selector.product_custom_engrave_glass) {
            if(_.selector.product_custom_engrave_glass.getAttribute('data-product-default-handle') === jsonedit.editengrave.handle) {
                window.addEventListener('DOMContentLoaded', (event) => {
                    _.selector.product_custom_engrave_glass.setAttribute('data-item-key',jsonedit.editengrave.line);                    
                   if(_.input.glass_firstline) _.input.glass_firstline.value = jsonedit.editengrave.firstline;
                   if(_.label.glass_firstline) _.label.glass_firstline.classList.add('focus');
                   if(_.input.glass_secondline) _.input.glass_secondline.value = jsonedit.editengrave.secondline;
                   if(_.label.glass_secondline) _.label.glass_secondline.classList.add('focus');
                   if(_.btn.product_page_add_to_cart) _.btn.product_page_add_to_cart.classList.add('d-none');
                   if(_.btn.product_edit_engrave) _.btn.product_edit_engrave.forEach(el => {
                        el.classList.remove('d-none');
                        el.addEventListener('click', (event) => {
                            theme.cartAddItem.engravingpropertyupdate(_.selector.product_custom_engrave_glass.getAttribute('data-item-key'),_.input.glass_firstline.value,_.input.glass_secondline.value,-1);
                            if(_.btn.product_page_glass_close) _.btn.product_page_glass_close.click();
                            if(_.input.bottle_firstline)_.input.bottle_firstline.value = '';
                            if(_.input.bottle_secondline) _.input.bottle_secondline.value ='';
                            if(_.input.bottle_thirdline) _.input.bottle_thirdline.value ='';
                            if(_.input.glass_firstline) _.input.glass_firstline.value = '';
                            if(_.input.glass_secondline) _.input.glass_secondline.value = '';
                        })
                    })      
                    _.btn.product_page_glass.click();
                });
            }
        }       
        if(_.selector.product_custom_engrave_drop) {
            if(_.selector.product_custom_engrave_drop.getAttribute('data-product-default-handle') === jsonedit.editengrave.handle) {
                window.addEventListener('DOMContentLoaded', (event) => {
                    _.selector.product_custom_engrave_drop.setAttribute('data-item-key',jsonedit.editengrave.line);                    
                   if(_.input.drop_firstline) _.input.drop_firstline.value = jsonedit.editengrave.firstline;
                   if(_.label.drop_firstline) _.label.drop_firstline.classList.add('focus');
                   if(_.input.drop_secondline) _.input.drop_secondline.value = jsonedit.editengrave.secondline;
                   if(_.label.drop_secondline) _.label.drop_secondline.classList.add('focus');
                   if(_.btn.product_page_add_to_cart) _.btn.product_page_add_to_cart.classList.add('d-none');
                   if(_.btn.product_edit_engrave) _.btn.product_edit_engrave.forEach(el => {
                        el.classList.remove('d-none');
                        el.addEventListener('click', (event) => {
                            theme.cartAddItem.engravingpropertyupdate(_.selector.product_custom_engrave_drop.getAttribute('data-item-key'),_.input.drop_firstline.value,_.input.drop_secondline.value,-1);
                            if(_.btn.product_page_drop_close) _.btn.product_page_drop_close.click();
                            if(_.input.bottle_firstline)_.input.bottle_firstline.value = '';
                            if(_.input.bottle_secondline) _.input.bottle_secondline.value ='';
                            if(_.input.bottle_thirdline) _.input.bottle_thirdline.value ='';
                            if(_.input.glass_firstline) _.input.glass_firstline.value = '';
                            if(_.input.glass_secondline) _.input.glass_secondline.value = '';
                            if(_.input.drop_firstline) _.input.drop_firstline.value = '';
                            if(_.input.drop_secondline) _.input.drop_secondline.value = '';
                        })
                    })      
                    _.btn.product_page_drop.click();
                });
            }
          }       
    }
    

  theme.customEngraving = new customEngraving;

}

theme.customEngraving();